import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../utils/constants';
import './ProfileSubNav.css';

const TABS = [
  { to: ROUTES.PROFILE_SETTINGS, label: 'Profile' },
  { to: ROUTES.PROFILE_FRIENDS, label: 'Friends' },
  { to: ROUTES.PROFILE_STATS, label: 'Stats' },
  { to: ROUTES.PROFILE_BOUT_HISTORY, label: 'Bout History' },
];

export default function ProfileSubNav() {
  const location = useLocation();
  return (
    <nav className="profile-subnav">
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`profile-subnav-tab ${location.pathname === tab.to ? 'active' : ''}`}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
